package com.sweetlime.dungeonamigo.presentation.ui.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors
import com.sweetlime.dungeonamigo.presentation.ui.theme.pixelFont
import com.sweetlime.dungeonamigo.presentation.ui.theme.silkFont

/** Shared app header: D20 logo lockup (left) + dice quick-roll button (right). */
@Composable
fun AppHeader(onDiceClick: () -> Unit = {}) {
    val pf = pixelFont()
    val sf = silkFont()

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(BrandColors.Vault)
            .padding(top = 54.dp, start = 18.dp, end = 18.dp, bottom = 12.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        // Logo lockup: D20 glyph + "Dungeon / AMIGO"
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            D20Badge(size = 48)
            Column {
                Text("DUNGEON", fontFamily = pf, fontSize = 12.sp, color = BrandColors.Ivory)
                Text("amigo", fontSize = 20.sp, color = BrandColors.Ember, letterSpacing = 2.sp)
            }
        }

        // Dice roll button
        Box(
            modifier = Modifier
                .size(44.dp)
                .clip(RoundedCornerShape(12.dp))
                .background(BrandColors.Ember.copy(alpha = 0.10f))
                .border(1.dp, BrandColors.Ember.copy(alpha = 0.4f), RoundedCornerShape(12.dp))
                .clickable(onClick = onDiceClick),
            contentAlignment = Alignment.Center,
        ) {
            Text("⚄", fontSize = 22.sp, color = BrandColors.Ember)
        }
    }
}

/** D20 badge: octagonal die shape with ember border and centered "DA" label. */
@Composable
private fun D20Badge(size: Int) {
    val sf = silkFont()
    Box(Modifier.size(size.dp), contentAlignment = Alignment.Center) {
        Canvas(Modifier.fillMaxSize()) {
            val w = this.size.width
            val h = this.size.height
            val cut = w * 0.22f
            val path = Path()
            path.moveTo(cut, 0f)
            path.lineTo(w - cut, 0f)
            path.lineTo(w, cut)
            path.lineTo(w, h - cut)
            path.lineTo(w - cut, h)
            path.lineTo(cut, h)
            path.lineTo(0f, h - cut)
            path.lineTo(0f, cut)
            path.close()
            drawPath(path, Color(0xFF1A0E0A))
            drawPath(path, BrandColors.Ember.copy(alpha = 0.55f), style = Stroke(width = 2.dp.toPx()))
        }
        Text(
            text = "DA",
            color = BrandColors.Ivory,
            fontFamily = sf,
            fontSize = (size * 0.28f).sp,
        )
    }
}
